import React, { Component } from 'react'
import { graphql } from 'gatsby'
import { Container, Hero, HeroBody, Title } from 'bloomer'
import styled from 'styled-components'

// import Breadcrumbs from '../../components/breadcrumbs'
import Head from '../../components/head'
import Image from '../../components/image'
import Layout from '../../components/layout'
import Link from '../../components/link'

const ShortHeroBody = styled(HeroBody)`
  @media only screen and (min-width: 45rem) {
    padding-top: 9rem !important;
  }
`

const Cards = styled.ol`
  display: flex;
  flex-flow: row wrap;
  list-style-type: none;
`

const Card = styled.li`
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
  height: 360px;
  margin: 1rem auto;
  width: 320px;
`

const CardContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  height: 40%;
  justify-content: space-between;
  padding: 0.5rem 1rem 1rem 1rem;
`

const CardTitle = styled.h2`
  font-size: 1.1rem;
  font-weight: 500;
`

const CardContent = styled.div`
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
`

const Posts = ({ edges }) => {
  const renderedPosts = edges
    .sort((a, b) => new Date(b.node.frontmatter.date) - new Date(a.node.frontmatter.date))
    .filter(({ node }) => node.frontmatter.type === 'Article' || node.frontmatter.type === 'Pillar')
    .map(({ node }, index) => {
      const post = node.frontmatter
      const date = new Date(post.date)

      return (
        <Card key={index}>
          <Image file={post.banner} style={{ height: '60%' }} />
          <CardContainer>
            <CardTitle>
              <Link className={'learn-more-link'} style={{ fontSize: '1rem' }} to={`/${node.fields.slug}`}>
                {post.title}
              </Link>
            </CardTitle>
            <CardContent>
              <time dateTime={date} style={{ fontWeight: '500' }}>
                {date.toLocaleDateString('en-US', { timeZone: 'UTC' })}
              </time>
            </CardContent>
          </CardContainer>
        </Card>
      )
    })

  return <Cards>{renderedPosts}</Cards>
}

class RouteNation extends Component {
  render() {
    const {
      data: {
        allMarkdownRemark: { edges },
        logo
      }
    } = this.props

    return (
      <Layout>
        <Head
          article
          banner={logo.file}
          author={'Route'}
          title={'Route Nation'}
          description={`Route Nation provides educational and relevant industry specific content to Route's user community. Topics include walkthroughs, proposals, schedule management, team management, workflow management and more.`}
          keywords={[
            'route',
            'route the service platform',
            'business management software',
            'software for service companies',
            'route nation'
          ]}
          {...this.props}
        />
        {/* <Breadcrumbs {...this.props} /> */}
        <Hero isColor={'light'} isSize={'large'}>
          <ShortHeroBody>
            <Container>
              <Title isSize={1} className={'huge'} hasTextAlign={`centered`}>
                Route Nation
              </Title>
              <Posts edges={edges} />
            </Container>
          </ShortHeroBody>
        </Hero>
      </Layout>
    )
  }
}

export const query = graphql`
  query RouteNation {
    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { draft: { ne: true }, type: { ne: "Podcast" } } }
    ) {
      edges {
        node {
          html
          excerpt
          timeToRead
          frontmatter {
            title
            banner {
              publicURL
              childImageSharp {
                fixed(width: 320) {
                  ...GatsbyImageSharpFixed
                }
              }
            }
            date
            draft
            type
          }
          fields {
            slug
          }
        }
      }
    }
    logo: file(relativePath: { eq: "assets/logo/route-logo-full@2x.png" }) {
      childImageSharp {
        fixed(width: 1024) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`
// tableOfContents also available

export default RouteNation
